import { BoxProps } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { PropsWithChildren } from "react";

import { Icon } from "#shared/icons/Icon";
import { Flex } from "#shared/view/components/Flex";
import { Grid } from "#shared/view/components/Grid";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";
import { Collapse } from "#shared/view/designSystem/Collapse";
import { UnstyledButton } from "#shared/view/designSystem/UnstyledButton";

type Props = {
  title: string;
  color?: string;
  textOn?: string;
  textOff?: string;
};

export const Collapsable = ({
  children,
  title,
  textOn = "Ouvrir",
  textOff = "Masquer",
  ...props
}: PropsWithChildren<Props & BoxProps>) => {
  const [opened, { toggle }] = useDisclosure(false);

  if (!children) {
    return null;
  }

  const toggleState = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    toggle();
  };

  return (
    <Stack gap="xs">
      <Grid align="center" gap="0" columns={24}>
        <Grid.Col span="auto" mr={"auto"} flex="1">
          <Text {...props}>{title}</Text>
        </Grid.Col>

        <Grid.Col span="content" p={0}>
          <Flex justify="end" align={"center"}>
            <UnstyledButton onClick={toggleState} c={"dimmed"}>
              <Flex align="center">
                <Text fz={props.fz ?? "xs"} c={"dimmed"}>
                  {opened ? textOff : textOn}
                </Text>
                {opened ? (
                  <Icon name="chevronDown" size={18} />
                ) : (
                  <Icon name="chevronRight" size={18} />
                )}
              </Flex>
            </UnstyledButton>
          </Flex>
        </Grid.Col>
      </Grid>
      <Collapse expanded={opened}>{children}</Collapse>
    </Stack>
  );
};
